import Image from 'app/Components/Shared/Image/image';
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux';
import { resetState, goToPage, validateMailHandler, changeMailHandler, stepParams, setTimeDisconnectOccurred, disconnectProduct } from '../../DisconnectServiceSlice'
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit'
import images from '../../DisconnectPhotos/images'
import TextInput from '../../../../Shared/TextInput/TextInput';
import { PopUpContent } from '../DisconnectCommonParts/PopUpAction'
import PopUp from '../../../../Shared/Popup/PopUp'
import Config from '../../../../../Config'
import BtnWhite from '../../../../Shared/Buttons/BtnWhite';
import getDates from './datesToDisconnect'
import { Container, Row, Col } from 'reactstrap';
import gaParams from '../../../../../utilities/analytics/constants';
import { gaEvent } from '../../../../../utilities/analytics/tracking';
import { isBrowser } from "react-device-detect";
import Helper from '../../../../../utilities/analytics/helper'
import useExtendedEffect from '../../../../../utilities/hooks/useExtendedEffect';
import { clearStateHistoryAction } from '../../../../../utilities/stateHistory/stateHistorySlice';

function SummarizePickUpDisconnect(props) {

    const valid = props.mailForm.emailForm.valid;
    const [isShow, setIsShow] = useState(false);
    const [isShowOther, setIsShowOther] = useState(false)
    const [pickUpSectionShow, setPickUpSectionShow] = useState(false);
    const [deliveryError, SetDeliveryError] = useState(false);
    const [clicked, SetClicked] = useState(false);
    const [active, setActive] = useState(true);
    const displayPrice = '₪' + props.cost

    const hours = `${props.codes.deliveryAddress.start}-${props.codes.deliveryAddress.end}`
    const todaysDate = `${props.codes.deliveryAddress.hebDay} ${props.codes.deliveryAddress.date}`

    useEffect(() => {
        if (typeof window.scrollTo === "function") { 
            window.scrollTo(0, 0);
        } 
        gaEvent(gaParams.DISCONNECT_ENTER_SUMMARIZE_DISCONNECT_PAGE.category, gaParams.DISCONNECT_ENTER_SUMMARIZE_DISCONNECT_PAGE.eventType, props.serviceToDisconnect.serviceType);
      }, [props.finalDisconnectResponse])

      useEffect(() => {
        if(props.finalDisconnectResponse != "" && props.deliverySet === true) {
            if (typeof window.scrollTo === "function") { 
                window.scrollTo(0, 0);
            } 
        }
      }, [props.finalDisconnectResponse])

      useEffect(() => {
        if(props.mailForm.emailForm.email != '') {
            props.validateMailHandler(props.mailForm.emailForm);
            if(valid) {
                setActive(true);
            }
            if(props.emailInStore.email && props.emailInStore.email != "" && props.emailInStore.errors.email != "") {
                setActive(false);
            }
        }
    }, [valid, clicked, props.emailInStore.errors.email])

    // useEffect(() => {
    //     if(props.finalDisconnectResponse === true && props.deliverySet === true) {
    //         gaEvent(gaParams.DISCONNECT_ENTER_SUCCESSFUL_DISCONNECT_SUMMARY_PAGE.category, gaParams.DISCONNECT_ENTER_SUCCESSFUL_DISCONNECT_SUMMARY_PAGE.eventType, props.serviceToDisconnect.serviceType)
    //         setPickUpSectionShow(true);
    //     }
    //     else if(props.finalDisconnectResponse === false) {
    //         props.goToPage({ page: 'UNSUCCESSFUL_MOBILE_DISCONNECT', params: { ...stepParams, hideHeader: true } })
    //     }
    //     else if(props.finalDisconnectResponse === true && props.deliverySet === false) {
    //         gaEvent(gaParams.DISCONNECT_SHOW_BOX_WE_DONE_DISCONNECT_BUT_FAILED_DELIVERY.category, gaParams.DISCONNECT_SHOW_BOX_WE_DONE_DISCONNECT_BUT_FAILED_DELIVERY.eventType, props.serviceToDisconnect.serviceType)
    //         SetDeliveryError(true);
    //         props.goToPage({ page: 'GET_BACK_TO_YOU_BY_NUMBER', params: { ...stepParams, hideHeader: true } })
    //     }
    // },[props.finalDisconnectResponse, props.deliverySet])

    useExtendedEffect((runSideEffects) => {
        if (runSideEffects()) {
            if(props.finalDisconnectResponse === true && props.deliverySet === true) {
                gaEvent(gaParams.DISCONNECT_ENTER_SUCCESSFUL_DISCONNECT_SUMMARY_PAGE.category, gaParams.DISCONNECT_ENTER_SUCCESSFUL_DISCONNECT_SUMMARY_PAGE.eventType, props.serviceToDisconnect.serviceType)
                setPickUpSectionShow(true);
            }
            else if(props.finalDisconnectResponse === false) {
                props.goToPage({ page: 'GET_BACK_TO_YOU_BY_NUMBER', params: { ...stepParams, hideHeader: true } })
            }
            else if(props.finalDisconnectResponse === true && props.deliverySet === false) {
                gaEvent(gaParams.DISCONNECT_SHOW_BOX_WE_DONE_DISCONNECT_BUT_FAILED_DELIVERY.category, gaParams.DISCONNECT_SHOW_BOX_WE_DONE_DISCONNECT_BUT_FAILED_DELIVERY.eventType, props.serviceToDisconnect.serviceType)
                SetDeliveryError(true);
                props.goToPage({ page: 'GET_BACK_TO_YOU_BY_NUMBER', params: { ...stepParams, hideHeader: true } })
            }
        }
    }, [props.finalDisconnectResponse, props.deliverySet]);


    const days = ['יום א', 'יום ב', 'יום ג', 'יום ד', 'יום ה', 'יום ו', 'יום ש'];
    let today = new Date();
    const dd = String(today.getDate()).padStart(2, '0');
    const mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    const yyyy = today.getFullYear();
    today = dd + '.' + mm + '.' + yyyy;

    const todayFull = new Date();
    const todayStr = `${String(todayFull.getDate()).padStart(2, '0')}/${String(todayFull.getMonth() + 1).padStart(2, '0')}/${todayFull.getFullYear()}`;
    const dayName = days[todayFull.getDay()];
    const displayFullDay = todayStr + ' ' + dayName;

    function closeItemsPopUp() {
        setIsShowOther(!isShowOther)
    }

    function closePopUp() {
        gaEvent(gaParams.DISCONNECT_CLICK_THINK_ABOUT_IT_ME_IN_POP_UP.category, gaParams.DISCONNECT_CLICK_THINK_ABOUT_IT_ME_IN_POP_UP.eventType, props.serviceToDisconnect.serviceType)
        setIsShow(false);
    }

    function getKits(kit) {
        let kitProducts = [];
        if(kit.kitProducts && kit.kitProducts.length > 0) {
            kitProducts = kit.kitProducts.map(function(kitProduct, index){
                let equipment = (props.equipmentList || []).find(function(equ){
                    return equ.id.value === kitProduct.productId
                })
                if(equipment) {
                    // Take image
                    return (
                    <div key={index} className="equipmentBox">
                        <div className="equipmentDetails">
                            <div>{equipment.description.value}</div>
                            <Image className="img" alt="equipment" src={Config.epiBaseUrl + equipment.photoSmall.value.url} />
                        </div>
                    </div> )  
                }
                else {
                    // default img
                    return (
                        <div key={index} className="equipmentBox">
                            <div className="equipmentDetails">
                                <div>{kitProduct.title}</div>
                                <Image alt="not found" src={images.default} className="img" /> 
                            </div>
                        </div> 
                    )  
                }
            })
        }
        return kitProducts;
    }

    const kits = props.equipmentForProductData.kitList.map(function(kit, index){
        return <Row key={index} className="equipment-row">
                    <div className="equipment-info-header">{kit.counter > 1 ? `${kit.counter} ${kit.kitTitle}`: `${kit.kitTitle}`}</div>
                    {kit.counter > 1 ? <span className="span-txt">עבור כל אחד יש להחזיר: </span> : <span className="span-txt">עבורו יש להחזיר: </span>}
                    {getKits(kit)}
                </Row>
    })

    function displayAllItemsToReturn() {
        gaEvent(gaParams.DISCONNECT_CLICK_ON_VIEW_PRODUCTS_IN_SUCCESSFUL_DISCONNECT_SUMMARY_PAGE.category, gaParams.DISCONNECT_CLICK_ON_VIEW_PRODUCTS_IN_SUCCESSFUL_DISCONNECT_SUMMARY_PAGE.eventType, props.serviceToDisconnect.serviceType)
        setIsShowOther(!isShowOther);
    }

    async function redirectTo() {
        gaEvent(gaParams.DISCONNECT_CLICK_DISCONNECT_ME_IN_POP_UP.category, gaParams.DISCONNECT_CLICK_DISCONNECT_ME_IN_POP_UP.eventType, props.serviceToDisconnect.serviceType)
        const today = getDates(1);

        const data = {
            ProductId: props.serviceToDisconnect.productId,
            Round: props.codes.round,
            Lfdat: props.codes.lfdat,
            WaitTo: props.codes.waitTo,
            WaitFrom: props.codes.waitFrom,
            PickLocation: props.codes.pickLocation,
            DisconnectReasons: props.reasons.disconnectReasons.join(", "),
            DisconnectReference: props.writtenProofNumber,
            DisconnectDate: today.options[0].date,
            HasDelivery: true,
            ShippingCost: props.cost,
            Street: props.deliverTo.streetName,
            City: props.deliverTo.cityName,
            HouseNum: props.deliverTo.home,
            AptNum: props.deliverTo.apartment,
            PhoneNumber: (props.reasons.returnToNumberForm.cellular != "" ? props.reasons.returnToNumberForm.cellular : props.UserInfo.contactNumber),
            Email: (props.reasons.emailForm.email != "" ? props.reasons.emailForm.email : null),
            NotesForDelivery: (props.reasons.deliveryNotes != "" ? props.reasons.deliveryNotes : "")
        }
        await props.disconnectProduct(data);

        setIsShow(false);
    }

    async function goBackHome() {
        props.clearStateHistoryAction();
        var content = await props.context.loadContentByPath(props.redirectTo);
        props.context.navigateTo(content);
    }

    function next() {
        props.emailInStore.email && props.emailInStore.email !== "" ? gaEvent(gaParams.DISCONNECT_CLICK_CONTINUE_SUMMARIZE_DISCONNECT_PAGE.category, gaParams.DISCONNECT_CLICK_CONTINUE_SUMMARIZE_DISCONNECT_PAGE.eventType, Helper.objToString({serviceType: props.serviceToDisconnect.serviceType, filledEmail: true}, gaParams.DISCONNECT_CLICK_CONTINUE_SUMMARIZE_DISCONNECT_PAGE.eventParams)) : gaEvent(gaParams.DISCONNECT_CLICK_CONTINUE_SUMMARIZE_DISCONNECT_PAGE.category, gaParams.DISCONNECT_CLICK_CONTINUE_SUMMARIZE_DISCONNECT_PAGE.eventType, Helper.objToString({serviceType: props.serviceToDisconnect.serviceType, filledEmail: false}, gaParams.DISCONNECT_CLICK_CONTINUE_SUMMARIZE_DISCONNECT_PAGE.eventParams));
        if(props.emailInStore.email && props.emailInStore.email != "" && props.emailInStore.errors.email != "") {
            setActive(false);
            return;
        }
        SetClicked(true);
        setIsShow(true);
    }


    return (
        <Container className="SummarizePickUpDisconnect-root"> 
            <Row className="header-row">
                {pickUpSectionShow == false ? <h3 className="header">שלב הסיכומים ואישור הניתוק</h3> : <h3 className="header">סיכום פרטי הניתוק</h3>}
                {pickUpSectionShow && clicked ? <h5 className="v-header">תודה שהיית איתנו</h5> : null}
                {pickUpSectionShow && clicked ? <h6 className="v-header">הניתוק הושלם ותוך כמה דקות השירות יעלם גם מהאזור האישי ומהרשימה שלך</h6> : null}
            </Row>
            {pickUpSectionShow && clicked ?
            <Row className="user-summary-number-row">
                <Col>
                    <div className="detail"><span className="txt">מספר אסמכתא: </span>{props.writtenProofNumber}</div>
                </Col>
            </Row> : null }
            {isBrowser ? 
            <Row className="user-details-row">
                <Col>
                    <div className="detail"><span className="txt">ת.ז: </span>{props.UserInfo.IDNumber}</div>
                </Col>
                <Col>
                    <div className="detail"><span className="txt">שם לקוח: </span>{props.UserInfo.firstName} {props.UserInfo.lastName}</div>
                </Col> 
                <Col>
                    <div className="detail"><span className="txt">תאריך: </span>{today}</div>
                </Col>
            </Row>
            :
            <>
            <Row className="user-details-row">
                <Col className="pl-1 pr-1">
                    <div className="detail"><span className="txt">שם לקוח: </span>{props.UserInfo.firstName} {props.UserInfo.lastName}</div>
                </Col> 
                <Col className="pl-0 pr-0">
                    <div className="detail"><span className="txt">תאריך: </span>{today}</div>
                </Col>
                
            </Row>
            <Row className="user-details-row-second">
                <Col className="pl-0 pr-0">
                    <div className="detail"><span className="txt">ת.ז: </span>{props.UserInfo.IDNumber}</div>
                </Col>
            </Row>
            </>
            }
            <Row className="service-disconnect-summary-row">
                <div className="service-disconnect-summary">
                    <h6 className="header">ניתוק מ: {props.serviceToDisconnect.title}</h6>
                    <div className="header-sub-txt">{props.serviceToDisconnect.email}</div>
                    <div className="header-sub-txt">מספר הלקוח: {props.serviceToDisconnect.customerId}</div>
                    <div className="header-sub-txt">בכתובת: {props.serviceToDisconnect.address}</div>
                    <div>
                        <h6 className="header">הניתוק ייכנס לתוקף בתאריך</h6>
                        <div className="header-sub-txt">{displayFullDay}</div>
                    </div>
                </div>
            </Row>
            <Row className="equipment-to-return-row"> 
                <div className="service-disconnect-summary">
                    <h6 className="header">רשימת הציוד להחזרה</h6>
                    <div className="header-sub-txt">תאריך אחרון להחזרה הינו ה - {props.equipmentForProductData.returnDay} <br/>אי החזרה הציוד תהיה כרוכה בתשלום העלות שלו.</div>
                    <div onClick={() => displayAllItemsToReturn()} className="linkTo">לצפייה ברשימה
                        <div className="arrow"/>
                    </div>
                    <PopUp showPopUp={isShowOther} onClose={closeItemsPopUp}>
                        <div className="kitPopUpContainer">
                            <h3 className="kit-header">רשימת הציוד להחזרה</h3>
                            <div className="kit-list-container">{kits}</div>
                        </div>
                    </PopUp>
                    <h6 className="header">אופן החזרת הציוד - שילוח</h6>
                        <span style={{direction: 'rtl'}} className="header-sub-txt">בעלות של {displayPrice}</span>
                    <h6 className="header">לכתובת</h6>  
                        <span className="header-sub-txt">רחוב {props.deliverTo.streetName}</span>
                        <span className="header-sub-txt">&nbsp; {props.deliverTo.home} </span>
                        {props.deliverTo.apartment && props.deliverTo.apartment != "" ? <span className="header-sub-txt">&nbsp;דירה: {props.deliverTo.apartment}</span> : null }
                        <br /> 
                        <span className="header-sub-txt">{props.deliverTo.cityName} </span>
                    <h6 className="header">ביום ושעה</h6>
                        <span className="header-sub-txt">{todaysDate}</span>
                        <br />
                        <span className="header-sub-txt">{hours}</span>
                    {props.reasons.returnToNumberForm.cellular != "" || props.reasons.returnToNumberForm.cellular == "" && props.notes != "" ? <h6 className="header">טלפון והערות לתאום מול שליח</h6> : null}
                        {props.reasons.returnToNumberForm.cellular != "" ? <span className="header-sub-txt">{props.reasons.returnToNumberForm.cellular}</span> : null}
                        {props.reasons.returnToNumberForm.cellular != "" ? <br /> : null}
                        {props.notes != "" ? <span className="header-sub-txt">{props.notes}</span> : null}
                </div>
            </Row>
            {props.finalDisconnectResponse === true ? null :
            <Row className="mail-input-row">
                <span className="txt">ואפשר גם לקבל את הסיכום למייל:</span>           
                <TextInput onChange={(e) => props.changeMailHandler({target: e.target, form: props.mailForm.emailForm})} id="mail-to" name="email" type="text" placeholder="כתובת מייל" /*required="required"*/ error={props.mailForm.emailForm.errors.email}/>
            </Row>
            }
            {props.finalDisconnectResponse === true && props.emailInStore.email !== "" ? 
                <div className="mail-msg" style={{fontWeight: 'bold', marginTop: '10px'}}>נשלח את הפרטים למייל שהזנת</div> : null
            }
            {deliveryError == false ? null :
            <Row className="failedDelivery-row">
                <div className="txt-container">
                    <div className="pink-txt">השליחות להחזרת הציוד לא תואמה</div>
                    <div className="regular-txt">נחזור אליך בקרוב לקביעת מועד לשליחות</div>
                </div>
            </Row>}
            <Row className="btn-row">
                {pickUpSectionShow == true ? <BtnWhite text={'סיום'} onclick={() => goBackHome()}/> : <div className={`btn-container${active ? ' Active' : ''}`}><BtnSubmit text="אישור וסיום" onclick={() => next()}/></div>}
            </Row>
                <PopUp showPopUp={isShow} onClose={closePopUp}>
                    <PopUpContent redirectTo={redirectTo} closePopUp={closePopUp}/>
                </PopUp>
        </Container>
    )
}

const mapStateToProps = (state) => ({
    stepParams: state.disconnectServicesBlock.stepParams,
    serviceToDisconnect: state.disconnectServicesBlock.serviceToDisconnect,
    deliverTo: state.addressForm.form,
    reasons: state.disconnectServicesBlock.summarizeUserDisconnectDetails,
    time: state.disconnectServicesBlock.summarizeUserDisconnectDetails.timeDisconnectScheduled,
    UserInfo: state.authentication.loginData.userDetails,
    equipmentForProductData: state.disconnectServicesBlock.equipmentForProductData,
    mailForm: state.disconnectServicesBlock.summarizeUserDisconnectDetails,
    notes: state.disconnectServicesBlock.summarizeUserDisconnectDetails.deliveryNotes,
    codes: state.disconnectServicesBlock.summarizeUserDisconnectDetails.deliveryCodes,
    finalDisconnectResponse: state.disconnectServicesBlock.finalDisconnectResponse,
    deliverySet: state.disconnectServicesBlock.deliverySet,
    deliveryMobile: state.disconnectServicesBlock.MobileToGetBackTo,
    writtenProofNumber: state.disconnectServicesBlock.writtenProofNumber,
    emailInStore: state.disconnectServicesBlock.summarizeUserDisconnectDetails.emailForm,
    method: state.disconnectServicesBlock.summarizeUserDisconnectDetails.equipmentReturnMethod
});
  
const mapDispatchToProps = {
    goToPage,
    setTimeDisconnectOccurred,
    changeMailHandler,
    validateMailHandler,
    disconnectProduct,
    resetState,
    clearStateHistoryAction
};

export default connect(mapStateToProps, mapDispatchToProps)(SummarizePickUpDisconnect);